package com.nonopn.skywatcher.common.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class APIUserSession(
    @SerialName("persistence_token")
    val persistenceToken: String,
    val login: String,
    val email: String,
    val admin: Boolean? = false,
    val name: String? = null,
    val surname: String? = null,
    val language: String? = "en",
    val gmt: Int? = 0,
    val uuid: String?,
    val firstname: String? = null,
    @SerialName("vault_size")
    val vaultSize: Long? = 0,
    val gems: Long? = 0,
    // val latitude: BigDecimal?,
    // val longitude: BigDecimal?,
    @SerialName("lightning_radius")
    val lightningRadius: Int? = 0,
    @SerialName("lightning_notification_type")
    val lightningNotificationType: String? = null,
    // val business: BusinessModel? = null,
    val rights: List<String>? = null
)
